const subscribers = new Set();
let activeRequests = 0;

const notify = () => {
  const isLoading = activeRequests > 0;
  subscribers.forEach((callback) => {
    try {
      callback(isLoading);
    } catch (error) {
      console.error('[loadingManager] subscriber callback failed.', error);
    }
  });
};

export const startLoading = () => {
  activeRequests += 1;
  notify();
};

export const stopLoading = () => {
  activeRequests = Math.max(0, activeRequests - 1);
  notify();
};

export const trackLoading = async (promiseFactory) => {
  startLoading();
  try {
    return await promiseFactory();
  } finally {
    stopLoading();
  }
};

export const subscribeToLoading = (callback) => {
  if (typeof callback !== 'function') {
    return () => {};
  }

  subscribers.add(callback);
  callback(activeRequests > 0);

  return () => {
    subscribers.delete(callback);
  };
};
